import { HOST_URL } from '../../config'
import { HttpStatus } from '../../constants/http-status.enum'
import type { ApiResponse } from '../index'
import type { IClientUID } from '../clients'

export interface CycleSetting {
    name: string
    cylinder1_worktime_ms: number
    delay_after_cylinder1_ms: number
    motor_worktime_ms: number
    delay_after_motor_ms: number
    cylinder2_worktime_ms: number
    cylinder2_inner_lowtime_ms: number
    cylinder2_inner_hightime_ms: number
    cylinder2_inner_repeat: number
    delay_after_cylinder2_ms: number
    cylinder2_repeat: number
    cylinder3_hightime_ms: number
    cylinder3_lowtime_ms: number
    delay_after_cylinder3_ms: number
}

export enum GpioType {
    Cylinder1 = 0,
    Cylinder2 = 1,
    Cylinder3 = 2,
    Motor = 3,
    Led = 4,
}

export enum GpioLevel {
    Low = 0,
    High = 1,
}

export enum CycleAction {
    Stop = 0,
    Start = 1,
}

export interface SettingsData {
    current_setting: number
    settings: CycleSetting[]
}

enum FilterFillerActionType {
    GetSettings = 0,
    SetSettings = 1,
    SetIoLevel = 2,
    CycleTask = 3,
}
async function _request(clientId: IClientUID, type: FilterFillerActionType, body?: string, signal?: AbortSignal): Promise<ApiResponse<string>> {
    const response = await fetch(`${HOST_URL}filter-filler`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ clientId, type, body }),
        signal,
    })
    const result = (await response.json()) as any
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function GetFilterFillerSettings(clientId: IClientUID): Promise<SettingsData> {
    const response = await _request(clientId, FilterFillerActionType.GetSettings)
    const json = JSON.parse(response.data)
    return json
}

export async function SetFilterFillerSettings(clientId: IClientUID, settings: SettingsData): Promise<void> {
    await _request(clientId, FilterFillerActionType.SetSettings, JSON.stringify(settings))
}

export async function SetIoLevelRequest(clientId: IClientUID, gpio: keyof typeof GpioType, level: GpioLevel): Promise<void> {
    const controller = new AbortController()
    const timeout = setTimeout(() => controller.abort(), 3000)
    try {
        await _request(clientId, FilterFillerActionType.SetIoLevel, JSON.stringify({ gpio, level }), controller.signal)
    } catch (err) {
        if ((err as Error).name === 'AbortError') {
            throw new Error('Request timed out')
        }
        throw err
    } finally {
        clearTimeout(timeout)
    }
}

export async function CycleTask(clientId: IClientUID, action: CycleAction): Promise<void> {
    const controller = new AbortController()
    const timeout = setTimeout(() => controller.abort(), 3000)
    try {
        await _request(clientId, FilterFillerActionType.CycleTask, JSON.stringify({ action }), controller.signal)
    } catch (err) {
        if ((err as Error).name === 'AbortError') {
            throw new Error('Request timed out')
        }
        throw err
    } finally {
        clearTimeout(timeout)
    }
}
